module.exports = __webpack_public_path__ + "img/winerackdog01.5dd5ab95.jpg";